// const NameFormatter = (createdByOrParams) => {
//     let createdBy;
//     if (createdByOrParams == null) {
//         return "";
//     }
//     // Check if the input is an object with a 'value' property
//     if (typeof createdByOrParams === "object" && createdByOrParams?.value) {
//         createdBy = createdByOrParams?.value;
//     } else {
//         createdBy = createdByOrParams;
//     }

//     if (createdBy == null) {
//         return "";
//     }

//     let createdByName;

//     if (typeof createdBy === "string" && createdBy.includes("@")) {
//         // Extracting the part before '@'
//         createdByName = createdBy.split("@")[0];

//         if (createdByName.includes(".")) {
//             createdByName = createdByName
//                 .split(".")
//                 .map((word) =>
//                     word.charAt(0).toUpperCase() +
//                     word.slice(1).toLowerCase() // Handle case sensitivity
//                 )
//                 .join(" ");
//         } else {
//             createdByName =
//                 createdByName.charAt(0).toUpperCase() +
//                 createdByName.slice(1).toLowerCase(); // Handle case sensitivity
//         }
//         return createdByName;
//     } else if (typeof createdBy === "string" && createdBy.includes(".")) {
//         // Handle names with '.' but no '@'
//         createdByName = createdBy
//             .split(".")
//             .map((word) =>
//                 word.charAt(0).toUpperCase() +
//                 word.slice(1).toLowerCase() // Handle case sensitivity
//             )
//             .join(" ");
//         return createdByName;
//     } else if (typeof createdBy === "string") {
//         // Handle plain strings without '.' or '@'
//         createdByName =
//             createdBy.charAt(0).toUpperCase() +
//             createdBy.slice(1).toLowerCase(); // Handle case sensitivity
//         return createdByName;
//     } else {
//         // Handle object case
//         if (createdBy?.value) {
//             return NameFormatter(createdBy?.value);
//         } else {
//             return ""; // Return empty string if createdBy is not a string or object with value property
//         }
//     }
// };

// export default NameFormatter;

const NameFormatter = (createdByOrParams) => {
  let createdBy;
  if (createdByOrParams == null) {
    return '';
  }

  if (typeof createdByOrParams === 'object' && createdByOrParams?.value) {
    createdBy = createdByOrParams?.value;
  } else {
    createdBy = createdByOrParams;
  }

  if (createdBy == null) {
    return '';
  }

  let createdByName;

  if (typeof createdBy === 'string') {
    if (createdBy.includes('@')) {
      createdByName = createdBy.split('@')[0];
    } else {
      createdByName = createdBy;
    }

    // Capitalize first letter after spaces, dots, or special characters
    createdByName = createdByName.replace(
      /[^a-zA-Z0-9]+(.)/g,
      (match, char) => ' ' + char.toUpperCase()
    );

    // Ensure first letter is capitalized
    createdByName = createdByName.charAt(0).toUpperCase() + createdByName.slice(1);

    return createdByName;
  }

  if (typeof createdBy === 'object' && createdBy?.value) {
    return NameFormatter(createdBy?.value);
  }

  return '';
};

export default NameFormatter;
